/**
 * ISSUE-1384. The team page's Player Stats panel: its copy and the one
 * mapping from the wire to the game box score's table shape, so the panel
 * reuses `BoxScoreTable` as is. Every column, cell and order arrives from
 * sports-api POST /team/player-stats-get; nothing is computed here.
 */
import type { typeBoxScoreTable } from "../gameDetail/boxScoreView";

export const TEAM_PLAYER_STATS_EMPTY_LINE =
  "No player stats for this team yet this season.";
export const TEAM_PLAYER_STATS_FAILED_LINE =
  "We could not load this team's player stats.";
export const TEAM_PLAYER_STATS_LOADING_LABEL = "Loading player stats";

type typeWireTable = {
  key: string;
  label: string;
  columns: { key: string; label: string }[];
  rows: {
    playerId: string;
    name: string;
    position?: string | null;
    headshotUrl?: string | null;
    cells: { key: string; display: string }[];
  }[];
};

/** A season table has no totals row: a team's season sums are the Stats tab's job. */
export function toPlayerStatsTables(
  tables: readonly typeWireTable[],
): typeBoxScoreTable[] {
  return tables.map((table) => ({
    key: table.key,
    label: table.label,
    columns: table.columns,
    rows: table.rows.map((row) => ({
      playerId: row.playerId,
      name: row.name,
      position: row.position ?? null,
      headshotUrl: row.headshotUrl ?? null,
      cells: row.cells,
    })),
    totals: [],
  }));
}
